import * as actionTypes from '../actions/actionTypes';

const initialState = {}

const currencyReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CREATE_CURRENCY: {
            return {
                ...state, ...action.data
            }
        }
        default: {
            return state;
        }
    }
}

export default currencyReducer;